// Client lib imports
const airbrake = require('client/lib/airbrake')
const { FriendlyRequestError } = require('client/lib/request')
// Client V2 common imports
const confirmModalActions = require('client-v2/common/containers/confirm-modal/actions')
const { processImageFinalCrop } = require('client-v2/common/containers/upload-image-modal/utils')

// Action types

const SHOW = 'COLLECTION_PROFILE_HEADER_IMAGE_MODAL_SHOW'
const HIDE = 'COLLECTION_PROFILE_HEADER_IMAGE_MODAL_HIDE'

// Action creators

function show(payload) {
  return {
    type: SHOW,
    payload
  }
}

function hide() {
  return {
    type: HIDE
  }
}

function showPreviewError(err) {
  airbrake.notify(err)
  return confirmModalActions.alert({
    heading: 'Image processing failed',
    subheading: 'We could not use that image. Please try another.'
  })
}

// Action dispatchers

function deleteImage() {
  return function (dispatch, getState) {
    const { headerImageModal } = getState()
    dispatch(hide())
    headerImageModal.onDelete()
  }
}

function dismiss() {
  return function (dispatch, getState) {
    const { headerImageModal } = getState()
    dispatch(hide())
    headerImageModal.onDismiss()
  }
}

function submitImage({ image, crop }) {
  return async function (dispatch, getState) {
    const { headerImageModal } = getState()
    try {
      const file = await processImageFinalCrop(image, crop)
      dispatch(hide())
      headerImageModal.onSubmit(file)
    } catch (err) {
      let message = 'We could not process this image.'
      if (err instanceof FriendlyRequestError) {
        message = err.message
      }
      dispatch(confirmModalActions.alert({
        heading: 'Sorry.',
        subheading: message
      }))
      throw err
    }
  }
}

module.exports = {
  // Action types
  HIDE,
  SHOW,
  // Action creators
  hide,
  show,
  // Action dispatchers
  deleteImage,
  dismiss,
  showPreviewError,
  submitImage
}
